<div class="table-tab" dir="rtl">
  <div *ngIf="loading" class="empty-box">
    <i class="fa fa-spinner fa-spin"></i>
    <span>در حال دریافت جدول ناوگان...</span>
  </div>

  <div *ngIf="!loading && !filteredRows.length && !searchText && !statusFilter && !qualityFilter" class="empty-box">
    <i class="fa fa-table"></i>
    <span>داده‌ای برای نمایش وجود ندارد</span>
  </div>

  <div class="box" *ngIf="!loading && (filteredRows.length || searchText || statusFilter || qualityFilter)">
    <div class="toolbar">
      <strong><i class="fa fa-table"></i> جزئیات کامل ناوگان</strong>
      <input [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" placeholder="جستجو نام، پلاک یا شناسه...">
      <select [(ngModel)]="statusFilter" (ngModelChange)="applyFilter()">
        <option value="">همه وضعیت‌ها</option>
        <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
      </select>
      <select [(ngModel)]="qualityFilter" (ngModelChange)="applyFilter()">
        <option value="">همه کیفیت‌های داده</option>
        <option *ngFor="let q of qualityOptions" [value]="q">{{ q }}</option>
      </select>
      <span class="sub">{{ toEn(filteredRows.length, 0) }} خودرو</span>
    </div>
    <div class="tablewrap">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>خودرو / راننده</th>
            <th>پلاک</th>
            <th (click)="toggleSort('DistanceKm')" class="sortable">مسافت{{ sortArrow('DistanceKm') }}</th>
            <th (click)="toggleSort('SafetyScore')" class="sortable">امتیاز ایمنی{{ sortArrow('SafetyScore') }}</th>
            <th>وضعیت</th>
            <th (click)="toggleSort('MaxSpeed')" class="sortable">حداکثر سرعت{{ sortArrow('MaxSpeed') }}</th>
            <th (click)="toggleSort('TotalEvents')" class="sortable">رویدادها{{ sortArrow('TotalEvents') }}</th>
            <th (click)="toggleSort('VeryHighRiskEvents')" class="sortable">بسیار پرریسک{{ sortArrow('VeryHighRiskEvents') }}</th>
            <th>ریسک سرعت</th>
            <th>ریسک کاهش سرعت</th>
            <th>ریسک شتاب</th>
            <th>اطمینان سرعت</th>
            <th>هشدار اصلی</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let x of filteredRows; let i = index; trackBy: trackByUnit">
            <td>{{ toEn(i + 1, 0) }}</td>
            <td class="name">{{ x.strFullName }}</td>
            <td>{{ x.strVehicleNo }}</td>
            <td>{{ toEn(x.DistanceKm) }} km</td>
            <td class="score" [ngClass]="scoreClass(x.SafetyScore)">{{ toEn(x.SafetyScore) }}</td>
            <td><span class="badge" [ngClass]="badgeClass(x.SafetyStatus)">{{ x.SafetyStatus }}</span></td>
            <td>{{ toEn(x.MaxSpeed, 0) }}</td>
            <td>{{ toEn(x.TotalEvents, 0) }}</td>
            <td class="red">{{ toEn(x.VeryHighRiskEvents, 0) }}</td>
            <td>{{ toEn(x.HighSpeedRisk) }}</td>
            <td>{{ toEn(x.DecelerationRisk) }}</td>
            <td>{{ toEn(x.AccelerationRisk) }}</td>
            <td [ngClass]="qualityClass(x.DataQuality)">{{ toEn(x.PeakSpeedConfidence, 0) }}%</td>
            <td class="warn">{{ x.MainWarning }}</td>
          </tr>
          <tr *ngIf="!filteredRows.length">
            <td colspan="14" class="empty-cell">خودرویی مطابق فیلتر یافت نشد</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
